<template>
  <div class="lv-colorpicker-wrapper">
    <div class="flex items-center h-12 w-full">
      <div class="lv-colorpicker__colorblock-wrap w-10 h-10" @click="toggleColorBlockOverlay">
        <div class="lv-colorpicker__colorblock w-full h-full rounded-full" :style="{ backgroundColor: localValue }"></div>
      </div>

      <span class="ml-4 block text-center font-bold btn btn-secondary flex-1" @click="toggleColorBlockOverlay">
        Scegli colore
      </span>
    </div>

    <LvOverlayPanel style="width: max-content" ref="ColorpickerOverlay" append-to="body" :show-close-icon="false" id="image_overlay_panel" alignRight>
      <ColorpickerCore v-model="localValue" v-bind="$props" style="width: 200px; transform: scale(1.05)" @close="close" />
    </LvOverlayPanel>
  </div>
</template>

<script>
import ColorpickerCore from './core.vue';
import Checkboard from './checkboard.vue';
import LvOverlayPanel from './overlay-panel';
import { trueValueMixin } from './lightvue-mixins';
export default {
  name: 'LvColorpicker',
  props: {
    label: {
      type: String,
      default: '',
    },
    hidePalette: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
      default: () => ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#795548'],
    },
  },
  mixins: [trueValueMixin],
  data() {
    return {
      localValue: '#607C8A',
    };
  },
  watch: {
    localValue() {
      if (this.localValue !== this.modelValue) {
        this.updateValue(this.localValue);
      }
    },
  },
  mounted() {
    this.localValue = this.modelValue;


  },
  components: {
    LvOverlayPanel: LvOverlayPanel,
    ColorpickerCore: ColorpickerCore,
    Checkboard,
  },
  computed: {
    // modelValue() {
    //   return this.$attrs.modelValue ? this.$attrs.modelValue : this.value;
    // },
  },
  methods: {
    toggleColorpickerOverlay(event) {
      this.$refs.ColorpickerOverlay.toggle(null, this.$refs.colorPickerInput.$el);
    },
    toggleColorBlockOverlay(event) {
      this.$refs.ColorpickerOverlay.toggle(event);
    },
    close() {
      this.$refs.ColorpickerOverlay.hide();
    },
    // updateValue(newValue) {
    //   this.$emit('input', newValue); // Only for Vue 2
    //   this.$emit('update:modelValue', newValue); // Only for Vue 3
    // },
  },
};
</script>

<style>
.lv-colorpicker__colorblock-wrap {
  position: relative;
}
</style>